export default __webpack_public_path__ + "static/media/blogcard7.efe2807a.png";